
import React from 'react';
import { Card } from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { ArrowRight, Calendar, CalendarMinus, CalendarPlus } from "lucide-react";
import { calculateWorkDaysAndHours } from './utils';
import { TimeOff } from './types';

interface TimeOffStepProps {
  formData: {
    timeOff: TimeOff;
  };
  onInputChange: (field: string, value: string, category: 'timeOff') => void;
  onNext: () => void;
}

const TimeOffStep: React.FC<TimeOffStepProps> = ({
  formData,
  onInputChange,
  onNext,
}) => {
  const { availableWorkDays, availableWorkHours } = calculateWorkDaysAndHours(formData.timeOff);

  const handleInputChange = (field: string, value: string) => {
    const numValue = value.replace(/\D/g, '');
    onInputChange(field, numValue, 'timeOff');
  };

  return (
    <div className="space-y-6">
      <div className="text-center space-y-2">
        <h3 className="text-2xl font-bold">When would you like to take breaks?</h3>
        <p className="text-muted-foreground">
          Let's plan your year around your ideal work-life balance
        </p>
      </div>

      <div className="space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div className="space-y-2">
            <Label htmlFor="vacation" className="flex items-center gap-2">
              <CalendarPlus className="h-4 w-4" />
              Vacation Days
            </Label>
            <Input
              id="vacation"
              type="text"
              inputMode="numeric"
              placeholder="Days per year"
              value={formData.timeOff.vacation}
              onChange={(e) => handleInputChange('vacation', e.target.value)}
            />
          </div>

          <div className="space-y-2">
            <Label htmlFor="sick" className="flex items-center gap-2">
              <CalendarMinus className="h-4 w-4" />
              Sick Days
            </Label>
            <Input
              id="sick"
              type="text"
              inputMode="numeric"
              placeholder="Days per year"
              value={formData.timeOff.sick}
              onChange={(e) => handleInputChange('sick', e.target.value)}
            />
          </div>

          <div className="space-y-2">
            <Label htmlFor="holidays" className="flex items-center gap-2">
              <Calendar className="h-4 w-4" />
              Holidays
            </Label>
            <Input
              id="holidays"
              type="text"
              inputMode="numeric"
              placeholder="Days per year"
              value={formData.timeOff.holidays}
              onChange={(e) => handleInputChange('holidays', e.target.value)}
            />
          </div>
        </div>

        <Card className="p-4 mt-4">
          <div className="space-y-2">
            <div className="flex justify-between">
              <span>Available Working Days:</span>
              <span className="font-bold">{availableWorkDays} days</span>
            </div>
            <div className="flex justify-between">
              <span>Available Working Hours:</span>
              <span className="font-bold">{availableWorkHours} hours</span>
            </div>
          </div>
        </Card>

        <Button 
          onClick={onNext}
          className="w-full mt-4"
        >
          View Your Crystal Ball Results
          <ArrowRight className="ml-2 h-4 w-4" />
        </Button>
      </div>
    </div>
  );
};

export default TimeOffStep;
